<template>
  <div class="my-5 container mx-auto px-5 lg:px-8">
    <h1 class="text-3xl font-bold text-h1Text">الاحصائيات</h1>

    <div
      v-if="
        requestsCount &&
          RenewalRequestsCount &&
          userData &&
          finishedMemberShipCount
      "
      id="requestsCount"
      class="my-5"
    >
      <h3 class="text-gray-600 font-medium text-xl">طلبات العضوية</h3>
      <div class="flex justify-around items-center flex-wrap">
        <div
          @click="
            $router.push({
              name: 'DoctorsPanel',
              params: { count: 'requestsCount' },
            })
          "
          class="transform w-full md:w-1/4 transition-all duration-300  hover:scale-110 hover:shadow-lg cursor-pointer m-5 rounded border-r-4 border-primary shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-primary w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M482.726,485.783l-22.65-132.603c-2.441-14.287-12.576-25.764-26.453-29.95l-61.092-18.433    c-1.265-14.934-7.388-29.023-17.578-40.175c-8.151-8.92-18.403-15.415-29.704-18.999c1.934-2.146,3.727-4.285,5.372-6.377    c14.528-18.477,22.306-38.833,24.286-52.724h4.713c12.258,0,22.231-9.972,22.231-22.231v-11.396    c0-8.181-4.602-15.594-11.523-19.441V106.05c0-4.141-3.357-7.498-7.498-7.498s-7.497,3.356-7.497,7.498v30.764    c-2.92,0.507-6.404,1.383-9.968,2.884c-0.365,0.133-0.72,0.287-1.056,0.472c-0.805,0.367-1.611,0.754-2.414,1.19V80.938    c0-16.693-13.58-30.273-30.273-30.273h-20.695c-7.138,0-14.111,2.487-19.637,7.005l-2.031,1.66c-3.73,3.05-8.438,4.73-13.257,4.73    c-4.819,0-9.528-1.68-13.258-4.73l-2.03-1.66c-5.526-4.517-12.499-7.005-19.637-7.005H200.38    c-16.693,0-30.273,13.58-30.273,30.273v60.422c-0.803-0.436-1.609-0.823-2.414-1.19c-0.336-0.185-0.69-0.339-1.055-0.472    c-3.564-1.501-7.049-2.377-9.968-2.884V59.025c0-24.278,19.752-44.03,44.03-44.03h110.601c24.279,0,44.03,19.752,44.03,44.03    v11.786c0,4.141,3.357,7.498,7.497,7.498s7.498-3.356,7.498-7.498V59.025C370.326,26.479,343.847,0,311.301,0H200.7    c-32.547,0-59.025,26.479-59.025,59.025v74.43c-6.921,3.847-11.523,11.259-11.523,19.441v11.396    c0,12.259,9.973,22.231,22.231,22.231h4.713c1.979,13.891,9.758,34.247,24.286,52.724c1.643,2.09,3.435,4.227,5.367,6.371    c-25.98,8.252-44.926,31.61-47.277,59.179L78.378,323.23c-13.877,4.186-24.013,15.663-26.453,29.95l-9.198,53.849    c-0.697,4.082,2.047,7.955,6.128,8.652c4.08,0.699,7.955-2.046,8.653-6.128l9.198-53.849c1.476-8.644,7.608-15.586,16.003-18.118    l56.505-17.049v14.831c-12.952,2.384-23.973,11.281-28.512,23.608c-1.205,3.272-1.954,6.698-2.226,10.182l-5.461,70.095    c-0.412,5.28,1.415,10.538,5.01,14.423c3.595,3.886,8.694,6.116,13.989,6.116h9.348c4.141,0,7.498-3.356,7.498-7.498    c0-4.142-3.357-7.497-7.498-7.497h-9.348c-1.129,0-2.215-0.474-2.982-1.304c-0.766-0.828-1.155-1.948-1.067-3.073l5.461-70.096    c0.165-2.111,0.618-4.186,1.348-6.167c3.158-8.575,11.686-14.382,21.223-14.449l1.235-0.009c0.058-0.001,0.115-0.001,0.172-0.001    c9.269,0,17.474,5.256,20.935,13.427c0.971,2.291,1.561,4.713,1.755,7.199l5.463,70.097c0.087,1.124-0.302,2.244-1.068,3.073    c-0.766,0.828-1.853,1.303-2.982,1.303h-9.348c-4.141,0-7.498,3.356-7.498,7.497c0,4.141,3.357,7.498,7.498,7.498h9.348    c5.295,0,10.395-2.229,13.989-6.116c3.596-3.887,5.423-9.144,5.011-14.422l-5.463-70.096c-0.32-4.102-1.295-8.101-2.898-11.884    c-4.939-11.657-15.5-19.762-27.938-21.955v-19.306l25.774-7.777c2.345,4.939,6.992,15.612,16.197,38.619    c9.277,23.214,20.808,52.969,31.867,81.895c0.079,0.243,0.17,0.48,0.272,0.712c7.38,19.311,14.539,38.225,20.662,54.541    c1.098,2.926,3.895,4.864,7.02,4.864c3.125,0,5.922-1.938,7.02-4.864c6.122-16.316,13.281-35.23,20.662-54.541    c0.103-0.232,0.193-0.47,0.272-0.712c11.051-28.909,22.576-58.645,31.849-81.852c9.217-23.037,13.868-33.719,16.214-38.662    l25.774,7.777v44.285c-17.858,3.469-31.385,19.219-31.385,38.077c0,21.391,17.403,38.795,38.795,38.795    c21.392,0,38.795-17.403,38.795-38.795c0-18.796-13.438-34.508-31.21-38.045v-39.792l56.506,17.049    c8.395,2.532,14.526,9.474,16.003,18.118l22.65,132.603c0.376,2.199-0.209,4.349-1.648,6.054c-1.438,1.704-3.459,2.644-5.69,2.644    H51.393c-2.231,0-4.251-0.939-5.69-2.644c-1.438-1.705-2.024-3.854-1.648-6.054l7.475-43.762c0.697-4.082-2.047-7.955-6.128-8.652    c-4.08-0.7-7.955,2.047-8.653,6.128l-7.475,43.762c-1.115,6.532,0.696,13.183,4.968,18.248C38.516,509.096,44.767,512,51.393,512    h409.214c6.626,0,12.878-2.904,17.151-7.969C482.03,498.966,483.841,492.315,482.726,485.783z M355.421,152.089    c3.995-0.996,7.202-0.978,7.238-0.977c1.292,0.017,2.548-0.285,3.664-0.87c0.334,0.831,0.531,1.724,0.531,2.654v11.396    c0,3.99-3.246,7.236-7.236,7.236h-4.197V152.089z M156.579,171.528L156.579,171.528h-4.197c-3.99,0-7.236-3.246-7.236-7.236    v-11.396c0-0.93,0.198-1.823,0.531-2.653c1.115,0.585,2.371,0.887,3.664,0.869c0.057,0.01,3.255-0.008,7.238,0.981V171.528z     M171.574,179.935v-19.698c2.272,0.681,4.757,0.588,7.051-0.369c3.935-1.642,6.477-5.455,6.477-9.716V80.938    c0-8.424,6.854-15.278,15.278-15.278h20.695c3.688,0,7.291,1.285,10.146,3.619l2.03,1.66c6.401,5.234,14.48,8.115,22.749,8.115    c8.269,0,16.348-2.882,22.749-8.115l2.03-1.66c2.854-2.334,6.458-3.619,10.146-3.619h20.695c8.424,0,15.278,6.854,15.278,15.278    v69.215c0,4.26,2.542,8.074,6.477,9.716c1.314,0.548,2.69,0.814,4.054,0.814c1.017,0,2.026-0.149,2.997-0.439v19.691    c0,10.947-7.568,32.205-21.594,50.043c-4.646,5.909-10.618,12.257-17.971,17.805c-0.233,0.156-0.456,0.325-0.669,0.505    c-11.391,8.422-26.038,14.874-44.192,14.874s-32.801-6.452-44.193-14.875c-0.213-0.179-0.435-0.348-0.667-0.503    c-7.353-5.549-13.325-11.897-17.972-17.806C179.143,212.141,171.574,190.882,171.574,179.935z M305.12,301.07L256,337.784    l-49.12-36.714c4.871-6.191,7.6-14.138,7.6-21.23v-12.086c11.551,6.212,25.334,10.404,41.52,10.404s29.97-4.192,41.52-10.404    v12.086C297.52,286.932,300.249,294.879,305.12,301.07z M194.367,292.701c-4.004-1.525-8.443-1.775-12.642-0.636    c-0.184,0.043-0.364,0.092-0.539,0.144l-25.903,7.816c4.381-21.542,21.873-38.688,44.202-42.009v21.824    C199.485,284.544,197.385,289.407,194.367,292.701z M214.716,352.889c-0.014-0.035-0.028-0.07-0.041-0.104    c-0.38-0.961-0.755-1.909-1.127-2.846c-0.067-0.17-0.134-0.339-0.201-0.507c-0.364-0.917-0.725-1.827-1.081-2.722    c-0.025-0.063-0.05-0.125-0.075-0.189c-1.111-2.793-2.182-5.472-3.212-8.039c-0.075-0.186-0.15-0.375-0.225-0.56    c-0.296-0.736-0.587-1.461-0.876-2.177c-0.106-0.263-0.211-0.523-0.316-0.783c-0.28-0.694-0.558-1.384-0.832-2.059    c-0.082-0.202-0.162-0.398-0.243-0.599c-0.497-1.226-0.983-2.421-1.457-3.586c-0.128-0.315-0.259-0.636-0.386-0.947    c-0.186-0.454-0.367-0.896-0.549-1.341c-0.196-0.48-0.392-0.956-0.584-1.424c-0.072-0.175-0.147-0.36-0.219-0.534    c-0.058-0.14-0.111-0.269-0.168-0.408c-0.866-2.104-1.689-4.087-2.47-5.952c-0.006-0.015-0.013-0.03-0.019-0.045    c-0.416-0.993-0.823-1.963-1.214-2.887c-0.203-0.479-0.403-0.95-0.599-1.412l42.245,31.574l-17.652,7.499    c-0.031,0.013-0.063,0.026-0.094,0.04l-7.37,3.131C215.533,354.955,215.124,353.919,214.716,352.889z M232.606,398.797    c-1.481-3.843-2.973-7.708-4.468-11.569c-2.338-6.039-4.571-11.781-6.708-17.251l2.798-1.189l11.432,13.289L232.606,398.797z     M256.145,459.735c-0.215-0.446-0.471-0.867-0.767-1.259c-3.388-8.955-7.688-20.286-12.447-32.753l7-38.325h12.138l7,38.325    C264.082,438.784,259.603,450.594,256.145,459.735z M264.881,372.404h-17.762l-8.405-9.77L256,355.291l17.286,7.343    L264.881,372.404z M283.862,387.228c-1.495,3.861-2.987,7.726-4.468,11.569l-3.054-16.721l11.432-13.289l2.798,1.189    C288.433,375.446,286.2,381.189,283.862,387.228z M312.58,315.18c-0.371,0.876-0.757,1.795-1.15,2.733    c-0.051,0.122-0.103,0.245-0.154,0.368c-0.389,0.93-0.785,1.88-1.195,2.869c-0.027,0.065-0.055,0.134-0.082,0.2    c-0.354,0.853-0.717,1.733-1.086,2.63c-0.069,0.168-0.134,0.323-0.203,0.492c-0.082,0.201-0.17,0.414-0.253,0.617    c-0.164,0.4-0.331,0.808-0.499,1.216c-0.206,0.503-0.411,1.004-0.622,1.519c-0.067,0.164-0.136,0.335-0.204,0.5    c-0.522,1.279-1.058,2.597-1.606,3.951c-0.086,0.212-0.171,0.42-0.257,0.635c-0.271,0.669-0.547,1.352-0.824,2.039    c-0.108,0.269-0.217,0.537-0.326,0.809c-0.286,0.709-0.575,1.427-0.867,2.155c-0.082,0.203-0.165,0.411-0.247,0.615    c-1.017,2.532-2.072,5.173-3.167,7.925c-0.036,0.091-0.072,0.18-0.108,0.272c-0.354,0.889-0.712,1.793-1.074,2.704    c-0.067,0.17-0.135,0.34-0.203,0.511c-0.374,0.942-0.751,1.894-1.133,2.861c-0.007,0.018-0.014,0.036-0.021,0.053    c-0.412,1.042-0.826,2.09-1.248,3.16l-7.377-3.134c-0.026-0.011-0.052-0.022-0.077-0.033l-17.662-7.503l42.245-31.574    C312.982,314.23,312.782,314.7,312.58,315.18z M330.814,292.21c-0.001,0-0.003-0.001-0.004-0.001    c-0.006-0.002-0.013-0.003-0.019-0.006c-4.35-1.305-8.99-1.089-13.157,0.498c-3.019-3.294-5.118-8.157-5.118-12.861v-21.835    c22.469,3.312,39.908,20.297,44.232,42.029L330.814,292.21z M389.001,398.375c0,13.124-10.677,23.8-23.8,23.8    s-23.8-10.676-23.8-23.8c0-13.124,10.677-23.8,23.8-23.8S389.001,385.251,389.001,398.375z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الباحثون</h6>
            <p class="text-primary text-3xl">
              {{ requestsCount.doctorsCount }}
            </p>
          </div>
        </div>
        <div
          @click="
            $router.push({
              name: 'LabsPanel',
              params: { count: 'requestsCount' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-yellow-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-yellow-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M296,232c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S301.52,232,296,232z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M256,172c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S261.52,172,256,172z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M136,432c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C146,436.48,141.52,432,136,432z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M454.416,407.678L326,179.381V58.286c11.641-4.127,20-15.248,20-28.286c0-16.542-13.458-30-30-30H196    c-16.542,0-30,13.458-30,30c0,13.038,8.359,24.159,20,28.286v121.095L57.584,407.678c-12.328,21.916-12.109,47.959,0.584,69.663    C70.86,499.043,93.448,512,118.59,512h274.82c25.142,0,47.729-12.957,60.422-34.659    C466.525,455.637,466.744,429.594,454.416,407.678z M204.716,186.902c0.842-1.496,1.284-3.185,1.284-4.902V60h10    c5.522,0,10-4.478,10-10s-4.478-10-10-10h-20c-5.514,0-10-4.486-10-10s4.486-10,10-10h120c5.514,0,10,4.486,10,10s-4.486,10-10,10    h-20c-5.522,0-10,4.478-10,10s4.478,10,10,10h10v122c0,1.718,0.442,3.405,1.284,4.902l58.941,104.787    c-35.995-2.915-71.865,4.365-104.821,21.43c-42.366,21.924-89.529,25.784-134,11.227L204.716,186.902z M436.567,467.244    C427.502,482.745,411.368,492,393.41,492H118.59c-17.958,0-34.092-9.255-43.157-24.756c-9.067-15.503-9.224-34.106-0.417-49.762    l42.408-75.392c20.576,7.185,41.84,10.812,63.437,10.812c3.197,0,6.402-0.079,9.613-0.238    c27.905-1.382,54.862-8.711,80.124-21.784c33.792-17.496,70.959-23.536,107.783-17.581l58.604,104.183    C445.791,433.138,445.635,451.741,436.567,467.244z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M216,232c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S232.542,232,216,232z M216,272    c-5.514,0-10-4.486-10-10c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10C226,267.514,221.514,272,216,272z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M376,432H176c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h200c5.522,0,10-4.478,10-10    C386,436.478,381.522,432,376,432z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">
               المختبرات
            </h6>
            <p class="text-yellow-800 text-3xl">{{ requestsCount.labCount }}</p>
          </div>
        </div>
        <div
          v-if="userData.status == 'super-admin'"
          @click="
            $router.push({
              name: 'CompaniesPanel',
              params: { count: 'requestsCount' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-red-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-red-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              id="Capa_1"
              enable-background="new 0 0 512 512"
              height="512"
              viewBox="0 0 512 512"
              width="512"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="m487 444.811h-6.347v-123.851c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v123.852h-159.104v-203.88h152.975c3.38 0 6.13 2.75 6.13 6.129v38.565c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-38.565c0-11.651-9.479-21.129-21.13-21.129h-152.975v-136.294c0-10.913-8.491-20.13-19.352-21.049v-15.045c0-10.956-8.556-20.209-19.479-21.065l-194.24-15.224c-12.265-.969-22.78 8.758-22.78 21.065v12.011c-11.123.95-19.351 10.254-19.351 21.05v373.429h-6.347c-13.785 0-25 11.215-25 25s11.215 25 25 25h462c13.785 0 25-11.215 25-25s-11.215-24.999-25-24.999zm-421.302-406.49c0-3.592 3.057-6.392 6.609-6.111l194.24 15.223c3.168.249 5.65 2.933 5.65 6.111v13.863l-206.5-16.184v-12.902zm-19.351 33.061c0-3.621 3.097-6.399 6.608-6.111l232.942 18.256c3.169.249 5.651 2.933 5.651 6.111v355.173h-20.957v-107.38c0-6.826-5.553-12.379-12.379-12.379h-69.68c-6.826 0-12.379 5.553-12.379 12.379v48.653c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-46.032h64.438v104.759h-64.438v-23.664c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v23.664h-129.806zm440.653 408.429h-462c-5.514 0-10-4.486-10-10s4.486-10 10-10h462c5.514 0 10 4.486 10 10s-4.486 10-10 10z"
                    />
                    <path
                      d="m75.905 162.943h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 162.943h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 162.943h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 230.38h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.358c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.137 5.806 12.943 12.942 12.943zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 230.38h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 230.38h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 297.816h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m144.551 325.052h-67.188c-7.94 0-14.4 6.46-14.4 14.4v20.442c0 7.94 6.46 14.4 14.4 14.4h67.188c7.94 0 14.4-6.46 14.4-14.4v-20.442c0-7.94-6.46-14.4-14.4-14.4zm-.6 34.242h-65.988v-19.242h65.988z"
                    />
                    <path
                      d="m151.599 297.816h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 297.816h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m380.573 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m366.776 346.717h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m450.333 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.221v-21.887h28.221z"
                    />
                    <path
                      d="m436.536 346.717h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.221v-21.887h28.221z"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الشركات</h6>
            <p class="text-red-800 text-3xl">
              {{ requestsCount.companiesCount }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        RenewalRequestsCount &&
          requestsCount &&
          userData &&
          finishedMemberShipCount
      "
      id="RenewalRequestsCount"
      class="my-5"
    >
      <h3 class="text-gray-600 font-medium text-xl">طلبات التجديد</h3>
      <div class="flex justify-around items-center flex-wrap">
        <div
          @click="
            $router.push({
              name: 'DoctorsPanel',
              params: { count: 'RenewalRequestsCount' },
            })
          "
          class="transform w-full md:w-1/4 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer m-5 rounded border-r-4 border-primary shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-primary w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M482.726,485.783l-22.65-132.603c-2.441-14.287-12.576-25.764-26.453-29.95l-61.092-18.433    c-1.265-14.934-7.388-29.023-17.578-40.175c-8.151-8.92-18.403-15.415-29.704-18.999c1.934-2.146,3.727-4.285,5.372-6.377    c14.528-18.477,22.306-38.833,24.286-52.724h4.713c12.258,0,22.231-9.972,22.231-22.231v-11.396    c0-8.181-4.602-15.594-11.523-19.441V106.05c0-4.141-3.357-7.498-7.498-7.498s-7.497,3.356-7.497,7.498v30.764    c-2.92,0.507-6.404,1.383-9.968,2.884c-0.365,0.133-0.72,0.287-1.056,0.472c-0.805,0.367-1.611,0.754-2.414,1.19V80.938    c0-16.693-13.58-30.273-30.273-30.273h-20.695c-7.138,0-14.111,2.487-19.637,7.005l-2.031,1.66c-3.73,3.05-8.438,4.73-13.257,4.73    c-4.819,0-9.528-1.68-13.258-4.73l-2.03-1.66c-5.526-4.517-12.499-7.005-19.637-7.005H200.38    c-16.693,0-30.273,13.58-30.273,30.273v60.422c-0.803-0.436-1.609-0.823-2.414-1.19c-0.336-0.185-0.69-0.339-1.055-0.472    c-3.564-1.501-7.049-2.377-9.968-2.884V59.025c0-24.278,19.752-44.03,44.03-44.03h110.601c24.279,0,44.03,19.752,44.03,44.03    v11.786c0,4.141,3.357,7.498,7.497,7.498s7.498-3.356,7.498-7.498V59.025C370.326,26.479,343.847,0,311.301,0H200.7    c-32.547,0-59.025,26.479-59.025,59.025v74.43c-6.921,3.847-11.523,11.259-11.523,19.441v11.396    c0,12.259,9.973,22.231,22.231,22.231h4.713c1.979,13.891,9.758,34.247,24.286,52.724c1.643,2.09,3.435,4.227,5.367,6.371    c-25.98,8.252-44.926,31.61-47.277,59.179L78.378,323.23c-13.877,4.186-24.013,15.663-26.453,29.95l-9.198,53.849    c-0.697,4.082,2.047,7.955,6.128,8.652c4.08,0.699,7.955-2.046,8.653-6.128l9.198-53.849c1.476-8.644,7.608-15.586,16.003-18.118    l56.505-17.049v14.831c-12.952,2.384-23.973,11.281-28.512,23.608c-1.205,3.272-1.954,6.698-2.226,10.182l-5.461,70.095    c-0.412,5.28,1.415,10.538,5.01,14.423c3.595,3.886,8.694,6.116,13.989,6.116h9.348c4.141,0,7.498-3.356,7.498-7.498    c0-4.142-3.357-7.497-7.498-7.497h-9.348c-1.129,0-2.215-0.474-2.982-1.304c-0.766-0.828-1.155-1.948-1.067-3.073l5.461-70.096    c0.165-2.111,0.618-4.186,1.348-6.167c3.158-8.575,11.686-14.382,21.223-14.449l1.235-0.009c0.058-0.001,0.115-0.001,0.172-0.001    c9.269,0,17.474,5.256,20.935,13.427c0.971,2.291,1.561,4.713,1.755,7.199l5.463,70.097c0.087,1.124-0.302,2.244-1.068,3.073    c-0.766,0.828-1.853,1.303-2.982,1.303h-9.348c-4.141,0-7.498,3.356-7.498,7.497c0,4.141,3.357,7.498,7.498,7.498h9.348    c5.295,0,10.395-2.229,13.989-6.116c3.596-3.887,5.423-9.144,5.011-14.422l-5.463-70.096c-0.32-4.102-1.295-8.101-2.898-11.884    c-4.939-11.657-15.5-19.762-27.938-21.955v-19.306l25.774-7.777c2.345,4.939,6.992,15.612,16.197,38.619    c9.277,23.214,20.808,52.969,31.867,81.895c0.079,0.243,0.17,0.48,0.272,0.712c7.38,19.311,14.539,38.225,20.662,54.541    c1.098,2.926,3.895,4.864,7.02,4.864c3.125,0,5.922-1.938,7.02-4.864c6.122-16.316,13.281-35.23,20.662-54.541    c0.103-0.232,0.193-0.47,0.272-0.712c11.051-28.909,22.576-58.645,31.849-81.852c9.217-23.037,13.868-33.719,16.214-38.662    l25.774,7.777v44.285c-17.858,3.469-31.385,19.219-31.385,38.077c0,21.391,17.403,38.795,38.795,38.795    c21.392,0,38.795-17.403,38.795-38.795c0-18.796-13.438-34.508-31.21-38.045v-39.792l56.506,17.049    c8.395,2.532,14.526,9.474,16.003,18.118l22.65,132.603c0.376,2.199-0.209,4.349-1.648,6.054c-1.438,1.704-3.459,2.644-5.69,2.644    H51.393c-2.231,0-4.251-0.939-5.69-2.644c-1.438-1.705-2.024-3.854-1.648-6.054l7.475-43.762c0.697-4.082-2.047-7.955-6.128-8.652    c-4.08-0.7-7.955,2.047-8.653,6.128l-7.475,43.762c-1.115,6.532,0.696,13.183,4.968,18.248C38.516,509.096,44.767,512,51.393,512    h409.214c6.626,0,12.878-2.904,17.151-7.969C482.03,498.966,483.841,492.315,482.726,485.783z M355.421,152.089    c3.995-0.996,7.202-0.978,7.238-0.977c1.292,0.017,2.548-0.285,3.664-0.87c0.334,0.831,0.531,1.724,0.531,2.654v11.396    c0,3.99-3.246,7.236-7.236,7.236h-4.197V152.089z M156.579,171.528L156.579,171.528h-4.197c-3.99,0-7.236-3.246-7.236-7.236    v-11.396c0-0.93,0.198-1.823,0.531-2.653c1.115,0.585,2.371,0.887,3.664,0.869c0.057,0.01,3.255-0.008,7.238,0.981V171.528z     M171.574,179.935v-19.698c2.272,0.681,4.757,0.588,7.051-0.369c3.935-1.642,6.477-5.455,6.477-9.716V80.938    c0-8.424,6.854-15.278,15.278-15.278h20.695c3.688,0,7.291,1.285,10.146,3.619l2.03,1.66c6.401,5.234,14.48,8.115,22.749,8.115    c8.269,0,16.348-2.882,22.749-8.115l2.03-1.66c2.854-2.334,6.458-3.619,10.146-3.619h20.695c8.424,0,15.278,6.854,15.278,15.278    v69.215c0,4.26,2.542,8.074,6.477,9.716c1.314,0.548,2.69,0.814,4.054,0.814c1.017,0,2.026-0.149,2.997-0.439v19.691    c0,10.947-7.568,32.205-21.594,50.043c-4.646,5.909-10.618,12.257-17.971,17.805c-0.233,0.156-0.456,0.325-0.669,0.505    c-11.391,8.422-26.038,14.874-44.192,14.874s-32.801-6.452-44.193-14.875c-0.213-0.179-0.435-0.348-0.667-0.503    c-7.353-5.549-13.325-11.897-17.972-17.806C179.143,212.141,171.574,190.882,171.574,179.935z M305.12,301.07L256,337.784    l-49.12-36.714c4.871-6.191,7.6-14.138,7.6-21.23v-12.086c11.551,6.212,25.334,10.404,41.52,10.404s29.97-4.192,41.52-10.404    v12.086C297.52,286.932,300.249,294.879,305.12,301.07z M194.367,292.701c-4.004-1.525-8.443-1.775-12.642-0.636    c-0.184,0.043-0.364,0.092-0.539,0.144l-25.903,7.816c4.381-21.542,21.873-38.688,44.202-42.009v21.824    C199.485,284.544,197.385,289.407,194.367,292.701z M214.716,352.889c-0.014-0.035-0.028-0.07-0.041-0.104    c-0.38-0.961-0.755-1.909-1.127-2.846c-0.067-0.17-0.134-0.339-0.201-0.507c-0.364-0.917-0.725-1.827-1.081-2.722    c-0.025-0.063-0.05-0.125-0.075-0.189c-1.111-2.793-2.182-5.472-3.212-8.039c-0.075-0.186-0.15-0.375-0.225-0.56    c-0.296-0.736-0.587-1.461-0.876-2.177c-0.106-0.263-0.211-0.523-0.316-0.783c-0.28-0.694-0.558-1.384-0.832-2.059    c-0.082-0.202-0.162-0.398-0.243-0.599c-0.497-1.226-0.983-2.421-1.457-3.586c-0.128-0.315-0.259-0.636-0.386-0.947    c-0.186-0.454-0.367-0.896-0.549-1.341c-0.196-0.48-0.392-0.956-0.584-1.424c-0.072-0.175-0.147-0.36-0.219-0.534    c-0.058-0.14-0.111-0.269-0.168-0.408c-0.866-2.104-1.689-4.087-2.47-5.952c-0.006-0.015-0.013-0.03-0.019-0.045    c-0.416-0.993-0.823-1.963-1.214-2.887c-0.203-0.479-0.403-0.95-0.599-1.412l42.245,31.574l-17.652,7.499    c-0.031,0.013-0.063,0.026-0.094,0.04l-7.37,3.131C215.533,354.955,215.124,353.919,214.716,352.889z M232.606,398.797    c-1.481-3.843-2.973-7.708-4.468-11.569c-2.338-6.039-4.571-11.781-6.708-17.251l2.798-1.189l11.432,13.289L232.606,398.797z     M256.145,459.735c-0.215-0.446-0.471-0.867-0.767-1.259c-3.388-8.955-7.688-20.286-12.447-32.753l7-38.325h12.138l7,38.325    C264.082,438.784,259.603,450.594,256.145,459.735z M264.881,372.404h-17.762l-8.405-9.77L256,355.291l17.286,7.343    L264.881,372.404z M283.862,387.228c-1.495,3.861-2.987,7.726-4.468,11.569l-3.054-16.721l11.432-13.289l2.798,1.189    C288.433,375.446,286.2,381.189,283.862,387.228z M312.58,315.18c-0.371,0.876-0.757,1.795-1.15,2.733    c-0.051,0.122-0.103,0.245-0.154,0.368c-0.389,0.93-0.785,1.88-1.195,2.869c-0.027,0.065-0.055,0.134-0.082,0.2    c-0.354,0.853-0.717,1.733-1.086,2.63c-0.069,0.168-0.134,0.323-0.203,0.492c-0.082,0.201-0.17,0.414-0.253,0.617    c-0.164,0.4-0.331,0.808-0.499,1.216c-0.206,0.503-0.411,1.004-0.622,1.519c-0.067,0.164-0.136,0.335-0.204,0.5    c-0.522,1.279-1.058,2.597-1.606,3.951c-0.086,0.212-0.171,0.42-0.257,0.635c-0.271,0.669-0.547,1.352-0.824,2.039    c-0.108,0.269-0.217,0.537-0.326,0.809c-0.286,0.709-0.575,1.427-0.867,2.155c-0.082,0.203-0.165,0.411-0.247,0.615    c-1.017,2.532-2.072,5.173-3.167,7.925c-0.036,0.091-0.072,0.18-0.108,0.272c-0.354,0.889-0.712,1.793-1.074,2.704    c-0.067,0.17-0.135,0.34-0.203,0.511c-0.374,0.942-0.751,1.894-1.133,2.861c-0.007,0.018-0.014,0.036-0.021,0.053    c-0.412,1.042-0.826,2.09-1.248,3.16l-7.377-3.134c-0.026-0.011-0.052-0.022-0.077-0.033l-17.662-7.503l42.245-31.574    C312.982,314.23,312.782,314.7,312.58,315.18z M330.814,292.21c-0.001,0-0.003-0.001-0.004-0.001    c-0.006-0.002-0.013-0.003-0.019-0.006c-4.35-1.305-8.99-1.089-13.157,0.498c-3.019-3.294-5.118-8.157-5.118-12.861v-21.835    c22.469,3.312,39.908,20.297,44.232,42.029L330.814,292.21z M389.001,398.375c0,13.124-10.677,23.8-23.8,23.8    s-23.8-10.676-23.8-23.8c0-13.124,10.677-23.8,23.8-23.8S389.001,385.251,389.001,398.375z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 489.711 489.711"
              style="enable-background:new 0 0 489.711 489.711;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"
                  />
                  <path
                    d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الباحثون</h6>
            <p class="text-primary text-3xl">
              {{ RenewalRequestsCount.doctorsCount }}
            </p>
          </div>
        </div>
        <div
          @click="
            $router.push({
              name: 'LabsPanel',
              params: { count: 'RenewalRequestsCount' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-yellow-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-yellow-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M296,232c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S301.52,232,296,232z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M256,172c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S261.52,172,256,172z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M136,432c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C146,436.48,141.52,432,136,432z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M454.416,407.678L326,179.381V58.286c11.641-4.127,20-15.248,20-28.286c0-16.542-13.458-30-30-30H196    c-16.542,0-30,13.458-30,30c0,13.038,8.359,24.159,20,28.286v121.095L57.584,407.678c-12.328,21.916-12.109,47.959,0.584,69.663    C70.86,499.043,93.448,512,118.59,512h274.82c25.142,0,47.729-12.957,60.422-34.659    C466.525,455.637,466.744,429.594,454.416,407.678z M204.716,186.902c0.842-1.496,1.284-3.185,1.284-4.902V60h10    c5.522,0,10-4.478,10-10s-4.478-10-10-10h-20c-5.514,0-10-4.486-10-10s4.486-10,10-10h120c5.514,0,10,4.486,10,10s-4.486,10-10,10    h-20c-5.522,0-10,4.478-10,10s4.478,10,10,10h10v122c0,1.718,0.442,3.405,1.284,4.902l58.941,104.787    c-35.995-2.915-71.865,4.365-104.821,21.43c-42.366,21.924-89.529,25.784-134,11.227L204.716,186.902z M436.567,467.244    C427.502,482.745,411.368,492,393.41,492H118.59c-17.958,0-34.092-9.255-43.157-24.756c-9.067-15.503-9.224-34.106-0.417-49.762    l42.408-75.392c20.576,7.185,41.84,10.812,63.437,10.812c3.197,0,6.402-0.079,9.613-0.238    c27.905-1.382,54.862-8.711,80.124-21.784c33.792-17.496,70.959-23.536,107.783-17.581l58.604,104.183    C445.791,433.138,445.635,451.741,436.567,467.244z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M216,232c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S232.542,232,216,232z M216,272    c-5.514,0-10-4.486-10-10c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10C226,267.514,221.514,272,216,272z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M376,432H176c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h200c5.522,0,10-4.478,10-10    C386,436.478,381.522,432,376,432z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 489.711 489.711"
              style="enable-background:new 0 0 489.711 489.711;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"
                  />
                  <path
                    d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">
               المختبرات
            </h6>
            <p class="text-yellow-800 text-3xl">
              {{ RenewalRequestsCount.labCount }}
            </p>
          </div>
        </div>
        <div
          v-if="userData.status == 'super-admin'"
          @click="
            $router.push({
              name: 'CompaniesPanel',
              params: { count: 'RenewalRequestsCount' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-red-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-red-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              id="Capa_1"
              enable-background="new 0 0 512 512"
              height="512"
              viewBox="0 0 512 512"
              width="512"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="m487 444.811h-6.347v-123.851c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v123.852h-159.104v-203.88h152.975c3.38 0 6.13 2.75 6.13 6.129v38.565c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-38.565c0-11.651-9.479-21.129-21.13-21.129h-152.975v-136.294c0-10.913-8.491-20.13-19.352-21.049v-15.045c0-10.956-8.556-20.209-19.479-21.065l-194.24-15.224c-12.265-.969-22.78 8.758-22.78 21.065v12.011c-11.123.95-19.351 10.254-19.351 21.05v373.429h-6.347c-13.785 0-25 11.215-25 25s11.215 25 25 25h462c13.785 0 25-11.215 25-25s-11.215-24.999-25-24.999zm-421.302-406.49c0-3.592 3.057-6.392 6.609-6.111l194.24 15.223c3.168.249 5.65 2.933 5.65 6.111v13.863l-206.5-16.184v-12.902zm-19.351 33.061c0-3.621 3.097-6.399 6.608-6.111l232.942 18.256c3.169.249 5.651 2.933 5.651 6.111v355.173h-20.957v-107.38c0-6.826-5.553-12.379-12.379-12.379h-69.68c-6.826 0-12.379 5.553-12.379 12.379v48.653c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-46.032h64.438v104.759h-64.438v-23.664c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v23.664h-129.806zm440.653 408.429h-462c-5.514 0-10-4.486-10-10s4.486-10 10-10h462c5.514 0 10 4.486 10 10s-4.486 10-10 10z"
                    />
                    <path
                      d="m75.905 162.943h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 162.943h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 162.943h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 230.38h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.358c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.137 5.806 12.943 12.942 12.943zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 230.38h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 230.38h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 297.816h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m144.551 325.052h-67.188c-7.94 0-14.4 6.46-14.4 14.4v20.442c0 7.94 6.46 14.4 14.4 14.4h67.188c7.94 0 14.4-6.46 14.4-14.4v-20.442c0-7.94-6.46-14.4-14.4-14.4zm-.6 34.242h-65.988v-19.242h65.988z"
                    />
                    <path
                      d="m151.599 297.816h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 297.816h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m380.573 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m366.776 346.717h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m450.333 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.221v-21.887h28.221z"
                    />
                    <path
                      d="m436.536 346.717h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.221v-21.887h28.221z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 489.711 489.711"
              style="enable-background:new 0 0 489.711 489.711;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"
                  />
                  <path
                    d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الشركات</h6>
            <p class="text-red-800 text-3xl">
              {{ RenewalRequestsCount.companiesCount }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        RenewalRequestsCount &&
          requestsCount &&
          userData &&
          finishedMemberShipCount
      "
      id="finishedMemberShipCount"
      class="my-5"
    >
      <h3 class="text-gray-600 font-medium text-xl">المنتهي العضوية</h3>
      <div class="flex justify-around items-center flex-wrap">
        <div
          @click="
            $router.push({
              name: 'DoctorsPanel',
              params: { count: 'finishedDoctorsMemberShip' },
            })
          "
          class="transform w-full md:w-1/4 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer m-5 rounded border-r-4 border-primary shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-primary w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M482.726,485.783l-22.65-132.603c-2.441-14.287-12.576-25.764-26.453-29.95l-61.092-18.433    c-1.265-14.934-7.388-29.023-17.578-40.175c-8.151-8.92-18.403-15.415-29.704-18.999c1.934-2.146,3.727-4.285,5.372-6.377    c14.528-18.477,22.306-38.833,24.286-52.724h4.713c12.258,0,22.231-9.972,22.231-22.231v-11.396    c0-8.181-4.602-15.594-11.523-19.441V106.05c0-4.141-3.357-7.498-7.498-7.498s-7.497,3.356-7.497,7.498v30.764    c-2.92,0.507-6.404,1.383-9.968,2.884c-0.365,0.133-0.72,0.287-1.056,0.472c-0.805,0.367-1.611,0.754-2.414,1.19V80.938    c0-16.693-13.58-30.273-30.273-30.273h-20.695c-7.138,0-14.111,2.487-19.637,7.005l-2.031,1.66c-3.73,3.05-8.438,4.73-13.257,4.73    c-4.819,0-9.528-1.68-13.258-4.73l-2.03-1.66c-5.526-4.517-12.499-7.005-19.637-7.005H200.38    c-16.693,0-30.273,13.58-30.273,30.273v60.422c-0.803-0.436-1.609-0.823-2.414-1.19c-0.336-0.185-0.69-0.339-1.055-0.472    c-3.564-1.501-7.049-2.377-9.968-2.884V59.025c0-24.278,19.752-44.03,44.03-44.03h110.601c24.279,0,44.03,19.752,44.03,44.03    v11.786c0,4.141,3.357,7.498,7.497,7.498s7.498-3.356,7.498-7.498V59.025C370.326,26.479,343.847,0,311.301,0H200.7    c-32.547,0-59.025,26.479-59.025,59.025v74.43c-6.921,3.847-11.523,11.259-11.523,19.441v11.396    c0,12.259,9.973,22.231,22.231,22.231h4.713c1.979,13.891,9.758,34.247,24.286,52.724c1.643,2.09,3.435,4.227,5.367,6.371    c-25.98,8.252-44.926,31.61-47.277,59.179L78.378,323.23c-13.877,4.186-24.013,15.663-26.453,29.95l-9.198,53.849    c-0.697,4.082,2.047,7.955,6.128,8.652c4.08,0.699,7.955-2.046,8.653-6.128l9.198-53.849c1.476-8.644,7.608-15.586,16.003-18.118    l56.505-17.049v14.831c-12.952,2.384-23.973,11.281-28.512,23.608c-1.205,3.272-1.954,6.698-2.226,10.182l-5.461,70.095    c-0.412,5.28,1.415,10.538,5.01,14.423c3.595,3.886,8.694,6.116,13.989,6.116h9.348c4.141,0,7.498-3.356,7.498-7.498    c0-4.142-3.357-7.497-7.498-7.497h-9.348c-1.129,0-2.215-0.474-2.982-1.304c-0.766-0.828-1.155-1.948-1.067-3.073l5.461-70.096    c0.165-2.111,0.618-4.186,1.348-6.167c3.158-8.575,11.686-14.382,21.223-14.449l1.235-0.009c0.058-0.001,0.115-0.001,0.172-0.001    c9.269,0,17.474,5.256,20.935,13.427c0.971,2.291,1.561,4.713,1.755,7.199l5.463,70.097c0.087,1.124-0.302,2.244-1.068,3.073    c-0.766,0.828-1.853,1.303-2.982,1.303h-9.348c-4.141,0-7.498,3.356-7.498,7.497c0,4.141,3.357,7.498,7.498,7.498h9.348    c5.295,0,10.395-2.229,13.989-6.116c3.596-3.887,5.423-9.144,5.011-14.422l-5.463-70.096c-0.32-4.102-1.295-8.101-2.898-11.884    c-4.939-11.657-15.5-19.762-27.938-21.955v-19.306l25.774-7.777c2.345,4.939,6.992,15.612,16.197,38.619    c9.277,23.214,20.808,52.969,31.867,81.895c0.079,0.243,0.17,0.48,0.272,0.712c7.38,19.311,14.539,38.225,20.662,54.541    c1.098,2.926,3.895,4.864,7.02,4.864c3.125,0,5.922-1.938,7.02-4.864c6.122-16.316,13.281-35.23,20.662-54.541    c0.103-0.232,0.193-0.47,0.272-0.712c11.051-28.909,22.576-58.645,31.849-81.852c9.217-23.037,13.868-33.719,16.214-38.662    l25.774,7.777v44.285c-17.858,3.469-31.385,19.219-31.385,38.077c0,21.391,17.403,38.795,38.795,38.795    c21.392,0,38.795-17.403,38.795-38.795c0-18.796-13.438-34.508-31.21-38.045v-39.792l56.506,17.049    c8.395,2.532,14.526,9.474,16.003,18.118l22.65,132.603c0.376,2.199-0.209,4.349-1.648,6.054c-1.438,1.704-3.459,2.644-5.69,2.644    H51.393c-2.231,0-4.251-0.939-5.69-2.644c-1.438-1.705-2.024-3.854-1.648-6.054l7.475-43.762c0.697-4.082-2.047-7.955-6.128-8.652    c-4.08-0.7-7.955,2.047-8.653,6.128l-7.475,43.762c-1.115,6.532,0.696,13.183,4.968,18.248C38.516,509.096,44.767,512,51.393,512    h409.214c6.626,0,12.878-2.904,17.151-7.969C482.03,498.966,483.841,492.315,482.726,485.783z M355.421,152.089    c3.995-0.996,7.202-0.978,7.238-0.977c1.292,0.017,2.548-0.285,3.664-0.87c0.334,0.831,0.531,1.724,0.531,2.654v11.396    c0,3.99-3.246,7.236-7.236,7.236h-4.197V152.089z M156.579,171.528L156.579,171.528h-4.197c-3.99,0-7.236-3.246-7.236-7.236    v-11.396c0-0.93,0.198-1.823,0.531-2.653c1.115,0.585,2.371,0.887,3.664,0.869c0.057,0.01,3.255-0.008,7.238,0.981V171.528z     M171.574,179.935v-19.698c2.272,0.681,4.757,0.588,7.051-0.369c3.935-1.642,6.477-5.455,6.477-9.716V80.938    c0-8.424,6.854-15.278,15.278-15.278h20.695c3.688,0,7.291,1.285,10.146,3.619l2.03,1.66c6.401,5.234,14.48,8.115,22.749,8.115    c8.269,0,16.348-2.882,22.749-8.115l2.03-1.66c2.854-2.334,6.458-3.619,10.146-3.619h20.695c8.424,0,15.278,6.854,15.278,15.278    v69.215c0,4.26,2.542,8.074,6.477,9.716c1.314,0.548,2.69,0.814,4.054,0.814c1.017,0,2.026-0.149,2.997-0.439v19.691    c0,10.947-7.568,32.205-21.594,50.043c-4.646,5.909-10.618,12.257-17.971,17.805c-0.233,0.156-0.456,0.325-0.669,0.505    c-11.391,8.422-26.038,14.874-44.192,14.874s-32.801-6.452-44.193-14.875c-0.213-0.179-0.435-0.348-0.667-0.503    c-7.353-5.549-13.325-11.897-17.972-17.806C179.143,212.141,171.574,190.882,171.574,179.935z M305.12,301.07L256,337.784    l-49.12-36.714c4.871-6.191,7.6-14.138,7.6-21.23v-12.086c11.551,6.212,25.334,10.404,41.52,10.404s29.97-4.192,41.52-10.404    v12.086C297.52,286.932,300.249,294.879,305.12,301.07z M194.367,292.701c-4.004-1.525-8.443-1.775-12.642-0.636    c-0.184,0.043-0.364,0.092-0.539,0.144l-25.903,7.816c4.381-21.542,21.873-38.688,44.202-42.009v21.824    C199.485,284.544,197.385,289.407,194.367,292.701z M214.716,352.889c-0.014-0.035-0.028-0.07-0.041-0.104    c-0.38-0.961-0.755-1.909-1.127-2.846c-0.067-0.17-0.134-0.339-0.201-0.507c-0.364-0.917-0.725-1.827-1.081-2.722    c-0.025-0.063-0.05-0.125-0.075-0.189c-1.111-2.793-2.182-5.472-3.212-8.039c-0.075-0.186-0.15-0.375-0.225-0.56    c-0.296-0.736-0.587-1.461-0.876-2.177c-0.106-0.263-0.211-0.523-0.316-0.783c-0.28-0.694-0.558-1.384-0.832-2.059    c-0.082-0.202-0.162-0.398-0.243-0.599c-0.497-1.226-0.983-2.421-1.457-3.586c-0.128-0.315-0.259-0.636-0.386-0.947    c-0.186-0.454-0.367-0.896-0.549-1.341c-0.196-0.48-0.392-0.956-0.584-1.424c-0.072-0.175-0.147-0.36-0.219-0.534    c-0.058-0.14-0.111-0.269-0.168-0.408c-0.866-2.104-1.689-4.087-2.47-5.952c-0.006-0.015-0.013-0.03-0.019-0.045    c-0.416-0.993-0.823-1.963-1.214-2.887c-0.203-0.479-0.403-0.95-0.599-1.412l42.245,31.574l-17.652,7.499    c-0.031,0.013-0.063,0.026-0.094,0.04l-7.37,3.131C215.533,354.955,215.124,353.919,214.716,352.889z M232.606,398.797    c-1.481-3.843-2.973-7.708-4.468-11.569c-2.338-6.039-4.571-11.781-6.708-17.251l2.798-1.189l11.432,13.289L232.606,398.797z     M256.145,459.735c-0.215-0.446-0.471-0.867-0.767-1.259c-3.388-8.955-7.688-20.286-12.447-32.753l7-38.325h12.138l7,38.325    C264.082,438.784,259.603,450.594,256.145,459.735z M264.881,372.404h-17.762l-8.405-9.77L256,355.291l17.286,7.343    L264.881,372.404z M283.862,387.228c-1.495,3.861-2.987,7.726-4.468,11.569l-3.054-16.721l11.432-13.289l2.798,1.189    C288.433,375.446,286.2,381.189,283.862,387.228z M312.58,315.18c-0.371,0.876-0.757,1.795-1.15,2.733    c-0.051,0.122-0.103,0.245-0.154,0.368c-0.389,0.93-0.785,1.88-1.195,2.869c-0.027,0.065-0.055,0.134-0.082,0.2    c-0.354,0.853-0.717,1.733-1.086,2.63c-0.069,0.168-0.134,0.323-0.203,0.492c-0.082,0.201-0.17,0.414-0.253,0.617    c-0.164,0.4-0.331,0.808-0.499,1.216c-0.206,0.503-0.411,1.004-0.622,1.519c-0.067,0.164-0.136,0.335-0.204,0.5    c-0.522,1.279-1.058,2.597-1.606,3.951c-0.086,0.212-0.171,0.42-0.257,0.635c-0.271,0.669-0.547,1.352-0.824,2.039    c-0.108,0.269-0.217,0.537-0.326,0.809c-0.286,0.709-0.575,1.427-0.867,2.155c-0.082,0.203-0.165,0.411-0.247,0.615    c-1.017,2.532-2.072,5.173-3.167,7.925c-0.036,0.091-0.072,0.18-0.108,0.272c-0.354,0.889-0.712,1.793-1.074,2.704    c-0.067,0.17-0.135,0.34-0.203,0.511c-0.374,0.942-0.751,1.894-1.133,2.861c-0.007,0.018-0.014,0.036-0.021,0.053    c-0.412,1.042-0.826,2.09-1.248,3.16l-7.377-3.134c-0.026-0.011-0.052-0.022-0.077-0.033l-17.662-7.503l42.245-31.574    C312.982,314.23,312.782,314.7,312.58,315.18z M330.814,292.21c-0.001,0-0.003-0.001-0.004-0.001    c-0.006-0.002-0.013-0.003-0.019-0.006c-4.35-1.305-8.99-1.089-13.157,0.498c-3.019-3.294-5.118-8.157-5.118-12.861v-21.835    c22.469,3.312,39.908,20.297,44.232,42.029L330.814,292.21z M389.001,398.375c0,13.124-10.677,23.8-23.8,23.8    s-23.8-10.676-23.8-23.8c0-13.124,10.677-23.8,23.8-23.8S389.001,385.251,389.001,398.375z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <i class="bx bx-error-alt text-4xl"></i>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الباحثون</h6>
            <p class="text-primary text-3xl">
              {{ finishedMemberShipCount.doctorsCount }}
            </p>
          </div>
        </div>
        <div
          @click="
            $router.push({
              name: 'LabsPanel',
              params: { count: 'finishedLabsMemberShip' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-yellow-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-yellow-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M296,232c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S301.52,232,296,232z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M256,172c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S261.52,172,256,172z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M136,432c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C146,436.48,141.52,432,136,432z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M454.416,407.678L326,179.381V58.286c11.641-4.127,20-15.248,20-28.286c0-16.542-13.458-30-30-30H196    c-16.542,0-30,13.458-30,30c0,13.038,8.359,24.159,20,28.286v121.095L57.584,407.678c-12.328,21.916-12.109,47.959,0.584,69.663    C70.86,499.043,93.448,512,118.59,512h274.82c25.142,0,47.729-12.957,60.422-34.659    C466.525,455.637,466.744,429.594,454.416,407.678z M204.716,186.902c0.842-1.496,1.284-3.185,1.284-4.902V60h10    c5.522,0,10-4.478,10-10s-4.478-10-10-10h-20c-5.514,0-10-4.486-10-10s4.486-10,10-10h120c5.514,0,10,4.486,10,10s-4.486,10-10,10    h-20c-5.522,0-10,4.478-10,10s4.478,10,10,10h10v122c0,1.718,0.442,3.405,1.284,4.902l58.941,104.787    c-35.995-2.915-71.865,4.365-104.821,21.43c-42.366,21.924-89.529,25.784-134,11.227L204.716,186.902z M436.567,467.244    C427.502,482.745,411.368,492,393.41,492H118.59c-17.958,0-34.092-9.255-43.157-24.756c-9.067-15.503-9.224-34.106-0.417-49.762    l42.408-75.392c20.576,7.185,41.84,10.812,63.437,10.812c3.197,0,6.402-0.079,9.613-0.238    c27.905-1.382,54.862-8.711,80.124-21.784c33.792-17.496,70.959-23.536,107.783-17.581l58.604,104.183    C445.791,433.138,445.635,451.741,436.567,467.244z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M216,232c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S232.542,232,216,232z M216,272    c-5.514,0-10-4.486-10-10c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10C226,267.514,221.514,272,216,272z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M376,432H176c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h200c5.522,0,10-4.478,10-10    C386,436.478,381.522,432,376,432z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
            <i class="bx bx-error-alt text-4xl"></i>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">
               المختبرات
            </h6>
            <p class="text-yellow-800 text-3xl">
              {{ finishedMemberShipCount.labCount }}
            </p>
          </div>
        </div>
        <div
          v-if="userData.status == 'super-admin'"
          @click="
            $router.push({
              name: 'CompaniesPanel',
              params: { count: 'finishedCompaniesMemberShip' },
            })
          "
          class="transform w-full md:w-1/4 m-5 transition-all duration-300 hover:scale-110 hover:shadow-lg cursor-pointer rounded border-r-4 border-red-800 shadow-md p-5 flex items-center"
        >
          <div
            class="flex items-center justify-center text-red-800 w-1/4 text-5xl"
          >
            <svg
              class="fill-current w-16 h-16"
              xmlns="http://www.w3.org/2000/svg"
              id="Capa_1"
              enable-background="new 0 0 512 512"
              height="512"
              viewBox="0 0 512 512"
              width="512"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="m487 444.811h-6.347v-123.851c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v123.852h-159.104v-203.88h152.975c3.38 0 6.13 2.75 6.13 6.129v38.565c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-38.565c0-11.651-9.479-21.129-21.13-21.129h-152.975v-136.294c0-10.913-8.491-20.13-19.352-21.049v-15.045c0-10.956-8.556-20.209-19.479-21.065l-194.24-15.224c-12.265-.969-22.78 8.758-22.78 21.065v12.011c-11.123.95-19.351 10.254-19.351 21.05v373.429h-6.347c-13.785 0-25 11.215-25 25s11.215 25 25 25h462c13.785 0 25-11.215 25-25s-11.215-24.999-25-24.999zm-421.302-406.49c0-3.592 3.057-6.392 6.609-6.111l194.24 15.223c3.168.249 5.65 2.933 5.65 6.111v13.863l-206.5-16.184v-12.902zm-19.351 33.061c0-3.621 3.097-6.399 6.608-6.111l232.942 18.256c3.169.249 5.651 2.933 5.651 6.111v355.173h-20.957v-107.38c0-6.826-5.553-12.379-12.379-12.379h-69.68c-6.826 0-12.379 5.553-12.379 12.379v48.653c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-46.032h64.438v104.759h-64.438v-23.664c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v23.664h-129.806zm440.653 408.429h-462c-5.514 0-10-4.486-10-10s4.486-10 10-10h462c5.514 0 10 4.486 10 10s-4.486 10-10 10z"
                    />
                    <path
                      d="m75.905 162.943h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 162.943h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 162.943h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 230.38h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.358c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.137 5.806 12.943 12.942 12.943zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m151.599 230.38h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 230.38h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m75.905 297.816h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
                    />
                    <path
                      d="m144.551 325.052h-67.188c-7.94 0-14.4 6.46-14.4 14.4v20.442c0 7.94 6.46 14.4 14.4 14.4h67.188c7.94 0 14.4-6.46 14.4-14.4v-20.442c0-7.94-6.46-14.4-14.4-14.4zm-.6 34.242h-65.988v-19.242h65.988z"
                    />
                    <path
                      d="m151.599 297.816h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m227.292 297.816h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136 0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
                    />
                    <path
                      d="m380.573 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m366.776 346.717h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.222v-21.887h28.222z"
                    />
                    <path
                      d="m450.333 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.221v-21.887h28.221z"
                    />
                    <path
                      d="m436.536 346.717h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.221v-21.887h28.221z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <i class="bx bx-error-alt text-4xl"></i>
          </div>
          <div
            class="w-3/4 flex contents-between items-center flex-wrap border-r border-inputBorder pr-5 mr-5"
          >
            <h6 class="text-lg font-medium text-gray-600 w-full">الشركات</h6>
            <p class="text-red-800 text-3xl">
              {{ finishedMemberShipCount.companiesCount }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!requestsCount || !RenewalRequestsCount || !finishedMemberShipCount"
      class="flex my-5 justify-center items-center"
    >
      <i class="bx bx-loader-alt bx-spin text-6xl text-primary"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "Dashboard",
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("requestsCount");
    this.$store.dispatch("RenewalRequestsCount");
    this.$store.dispatch("finishedMemberShipCount");
    if (!this.userData) {
      this.$router.push({ name: "Signin" });
    }
  },
  computed: {
    requestsCount() {
      return this.$store.getters.requestsCount;
    },
    RenewalRequestsCount() {
      return this.$store.getters.RenewalRequestsCount;
    },
    finishedMemberShipCount() {
      return this.$store.getters.finishedMemberShipCount;
    },
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
